import { ProtectedRouter } from 'infrastructure/routing';
import { Routes, Route } from 'react-router-dom';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import ProjectsComplianceListPage from './List/ProjectsComplianceListPage';
import { PROJECTS_COMPLIACNE, PROJECTS_COMPLIANCE_LIST, useProjectsComplianceRoute } from './router';

const ProjectsComplianceRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useProjectsComplianceRoute();

  return (
    <ProtectedRouter basePath={PROJECTS_COMPLIACNE}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={PROJECTS_COMPLIANCE_LIST}>
              <ProjectsComplianceListPage />
            </GlobalProtectedRoute>
          }
        />
        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

ProjectsComplianceRouter.getRouterPath = () => `${PROJECTS_COMPLIACNE}/*`;

export default ProjectsComplianceRouter;
